import { Badge, BlockStack, Box, Card, Icon, InlineStack, TextField,Text } from '@shopify/polaris';
import React from 'react';
import {
    EmailIcon
  } from '@shopify/polaris-icons';
import './index.css'
import ButtonEmail from './ButtonEmail';
import ButtonPassword from './ButtonPassword';
const Index = ({pageData,setPageData})=> {
    return (
        <Box>
            <Card>
                <BlockStack gap={200}>
                    <Box>
                    <Text variant="headingSm" as="h6">
                    Account info
                    </Text>
                    </Box>
                    <InlineStack gap={400}>
                        <Box className="account_input_box">
                            <TextField
                            label="Account name"
                            value={pageData?.account_info?.account_name}
                            onChange={(value)=>{
                                if (value.length >= 20) {
                                    return
                                }
                                setPageData((prev)=>({
                                    ...prev,
                                    account_info:{...prev.account_info,account_name:value}
                                }))
                            }}
                            autoComplete="off"
                            />
                        </Box>
                        <Box className="account_input_box">
                            <Box className='Polaris-Labelled__LabelWrapper'>Account email (log in email)</Box>
                            <Box className="account_email_box">
                                <InlineStack blockAlign="center" gap={200} wrap={false}>
                                    <Box>
                                        <Icon source={EmailIcon} />
                                    </Box>
                                    <Box style={{flex:1}} >
                                        <Badge tone="info">
                                           <span className='account_email_box_text'>{pageData?.account_info?.account_email}</span> 
                                        </Badge>
                                    </Box>
                                    <Box>
                                        <ButtonEmail />
                                        {/* <Button variant='plain' removeUnderline>Change</Button> */}
                                    </Box>
                                </InlineStack>
                            </Box>
                        </Box>
                    </InlineStack>
                    <InlineStack gap={100} blockAlign='center'>
                        <ButtonPassword />
                        <Box>account password</Box>
                    </InlineStack>
                </BlockStack>
            </Card>
        </Box>
    );
}

export default Index;
